import { Box, Stack, TextField } from "@mui/material";
import { Avatar } from "@src/appV2/lib/Avatar";
import { Button } from "@src/appV2/redesign/components/Button";
import { Dropdown } from "antd";

import { Icon } from "@src/appV2/redesign/components/Icon";
import { Text } from "@src/appV2/redesign/components/Text";
import { AccountSwitcherMenuWorkplaceDesktop } from "./AccountSwitcherDropdownWorkplace";
import { useAccountSwitcher } from "../../Shared/AccountSwitcher/useAccountSwitcher";
import { AccountSwitcherDropdownAdminDesktop } from "./AccountSwitcherDropdownAdmin";

export function AccountSwitcherDesktop() {
  const {
    switcherTitle,
    switcherSubtitle,
    displayAdminSwitcher,
    dropdownVisible,
    onAdminSearchBarEntered,
    onDropdownButtonClicked,
    onDropdownMouseLeave,
    workerDetails,
    workplaceDetails,
    onSearchChanged,
    onUserClicked,
    onAdminClicked,
  } = useAccountSwitcher();

  return (
    <Dropdown
      overlay={() => (
        <Box
          sx={(theme) => ({
            maxHeight: "60vh",
            overflowY: "auto",
            background: theme.palette.navbar?.gradient,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
            padding: 3,
          })}
          onMouseLeave={onDropdownMouseLeave}
        >
          {displayAdminSwitcher ? (
            <AccountSwitcherDropdownAdminDesktop
              workerDetails={workerDetails}
              workplaceDetails={workplaceDetails}
              onUserClicked={onUserClicked}
              onAdminClicked={onAdminClicked}
            />
          ) : (
            <AccountSwitcherMenuWorkplaceDesktop
              workplaceDetails={workplaceDetails}
              onUserClicked={onUserClicked}
            />
          )}
        </Box>
      )}
      visible={dropdownVisible}
      placement="bottomRight"
    >
      {displayAdminSwitcher ? (
        /* TODO: replace text field, with redesigned component */
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search agents or workplaces..."
          sx={(theme) => ({
            marginBottom: 2,
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background?.inverted?.muted,
              color: theme.palette.navbar?.itemContentSelected,
              "& fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.normal?.borderColor,
              },
              "&:hover fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
              "&.Mui-focused fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
            },
            "& .MuiOutlinedInput-input": {
              color: theme.palette.navbar?.itemContentSelected,
              "&::placeholder": {
                color: theme.palette.navbar?.itemContent,
                opacity: 1,
              },
            },
          })}
          onClick={onAdminSearchBarEntered}
          onChange={(event) => {
            onSearchChanged(event.target.value);
          }}
        />
      ) : (
        <Button variant="outlineInverted" sx={{ height: "100%" }} onClick={onDropdownButtonClicked}>
          <Stack direction="row" minWidth="400px" alignItems="center" gap={3}>
            <Avatar
              name={switcherTitle}
              sx={(theme) => ({
                bgcolor: theme.palette.navbar?.avatarBackground,
                color: theme.palette.navbar?.avatarText,
                flexShrink: 0,
              })}
            />
            <Stack direction="column" flex={1} minWidth={0}>
              <Text
                variant="body1"
                textAlign="left"
                color={(theme) => theme.palette.navbar?.userName}
              >
                {switcherTitle}
              </Text>
              {switcherSubtitle && (
                <Text variant="caption" textAlign="left">
                  {switcherSubtitle}
                </Text>
              )}
            </Stack>
            <Icon
              type="caret-bottom"
              sx={(theme) => ({
                color: theme.palette.button?.outline.inverted.hover.color,
                flexShrink: 0,
              })}
            />
          </Stack>
        </Button>
      )}
    </Dropdown>
  );
}
